import * as api from 'services/api';
import { addError } from 'actions/error';

export const getProfessionInfo = (id, query) => (dispatch) =>
  api
    .get(
      `professions/${id}${query || ''}`,
      'GET_PROFESSION_INFO' + (query ? '_QUERY' : ''),
      dispatch
    )
    .catch((error) => {
      dispatch(addError(new Error('GET_PROFESSION_INFO_ERROR')));
      // Return null instead of the dispatch result so callers can check for failure
      return null;
    });

export const getTagsList = () => (dispatch) =>
  api.get('tags', 'GET_TAGS_LIST', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_TAGS_LIST_ERROR')));
    // Resolve with null on failure so callers get a checkable value.
    return null;
  });

export const getSkillsList = () => (dispatch) =>
  api.get('skills?level=name', 'GET_SKILLS_LIST', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_SKILLS_LIST_ERROR')));
    // Resolve with null on failure so callers get a checkable value.
    return null;
  });

export const getSkillInfo = (id) => (dispatch) =>
  api.get(`skills/${id}`, 'GET_SKILL_INFO', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_SKILL_INFO_ERROR')));
    // Resolve with null on failure so callers get a checkable value.
    return null;
  });

export const getVacancies = (id) => (dispatch) =>
  api.get(`professions/vacancies/${id}`, 'GET_VACANCIES', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_VACANCIES_ERROR')));
    // Resolve with null on failure (matches getProfessionInfo) so callers get a
    // checkable value instead of an Error object leaking into component state.
    return null;
  });

export const toggleFavorite = (id, isFavorite, endPoint) => (dispatch) => {
  if (isFavorite) {
    api
      .del(`${endPoint}/favorites/${id}`, {}, 'TOGGLE_FAVORITE', dispatch)
      .catch(() => dispatch(addError(new Error('TOGGLE_FAVORITE_ERROR'))));
  } else {
    api.post(`${endPoint}/favorites/${id}`, {}, 'TOGGLE_FAVORITE', dispatch).catch(() => {
      dispatch(addError(new Error('TOGGLE_FAVORITE_ERROR')));
    });
  }
};

export const getCategories = (filters) => (dispatch) => {
  const { target } = filters || {};
  const query = target ? `?filters.target=${target}` : '';
  return api
    .get(`profession-categories${query}`, 'GET_CATEGORIES', dispatch)
    .catch((error) => {
      dispatch(addError(new Error('GET_CATEGORIES_ERROR')));
      throw error;
    });
};

export const getPrograms =
  (query = '') =>
  (dispatch) =>
    api
      .get(
        `education/programs${query}`,
        'GET_EDUCATION_PROGRAM_INFO' + (query ? '_QUERY' : ''),
        dispatch
      )
      .catch(() => dispatch(addError(new Error('GET_EDUCATION_PROGRAM_INFO'))));
